import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    decisionButtons: {
        display: "flex",
        justifyContent: "space-between",
        "&:focus": {
            outline: "none",
        },
    },

    btnRed: {
        marginLeft: "10px",
        marginRight: "10px",
        marginTop: "1%",
        marginBottom: ".5%",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
    },

    btnDecisionRed: {
        backgroundColor: "red",
        fontSize: 24,
        color: "white",
        minWidth: 50,
        minHeight: 50,
        marginLeft: "10px",
        fontWeight: "bold",
        marginTop: "10px",
        marginBottom: "10px",
        "&:hover": {
            backgroundColor: "#ff6666",
        },
        "&:disabled": {
            backgroundColor: "#ff6666",
        },
    },

    btnBlue: {
        marginRight: "10px",
        marginLeft: "10px",
        marginTop: "1%",
        marginBottom: ".5%",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
    },

    btnDecisionBlue: {
        backgroundColor: "blue",
        fontSize: 24,
        color: "white",
        minWidth: 50,
        minHeight: 50,
        marginRight: "10px",
        marginTop: "10px",
        marginBottom: "10px",
        fontWeight: "bold",
        "&:hover": {
            backgroundColor: "#8080ff",
        },
        "&:disabled": {
            backgroundColor: "#8080ff",
        },
    },

    btnEndVideo: {},

    btnSlowMotion: {
        backgroundColor: "#0057d8",
        color: "white",
        marginLeft: "10px",
        marginTop: ".5%",
        marginBottom: ".5%",
        justifyContent: "center",
        alignItems: "center",
    },

    videoPlayerStartBtn: {
        justifyContent: "center",
        backgroundColor: "gray",
        "&:hover": {
            backgroundColor: "#989898",
            color: "#505050",
        },
    },
    icon: {
        minWidth: "5%",
        minHeight: "5%",
        width: "15%",
        height: "15%",
        verticalAlign: "center",
        textDecoration: "none",
        color: "black",
    },
    leftButtonGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
        gridTemplateRows: "repeat(2, 100px)"

    }
}));

export { useStyles };
